import {createSlice} from '@reduxjs/toolkit';
import reduxApis from "../apis";
import {toast} from "react-toastify";

const adminSlice = createSlice({
    name: 'Admin',
    initialState: {
        loading: false,
        adminUser: null,
        allUser: [],
        user: null,
        userSpecific: null,
        store: null,
        allStore: [],
        error: null,
        dropDown:false,
        notificationsAdmin:[],
        totalUnseenAdminNotifications:0
    },
    reducers: {
        adminLogout: (state, action) => {
            state.adminUser = null
            state.notificationsAdmin = [];
            state.dropDown=false
            state.totalUnseenAdminNotifications = 0
        },
        setAdmin : (state, action) => {
            state.adminUser = action.payload
        },
        setShowDropdown : (state, action) => {
            state.dropDown = action.payload
        },
        setReserveShares: (state, action) => {
            state.adminUser.reserveWallet.shares = action.payload
        },
        setAdminNotifications: (state, action) => {
            state.notificationsAdmin = action.payload
        },
        setTotalUnseenAdminNotifications: (state, action) => {
            state.totalUnseenAdminNotifications = action.payload
        }
    },
    extraReducers: {
        [reduxApis.adminLogin.pending]: (state, action) => {
            state.loading = true;
        },
        [reduxApis.adminLogin.fulfilled]: (state, action) => {
            toast.success(action.payload.data.message)
            state.loading = false;
            state.adminUser = action.payload.data.user;
        },
        [reduxApis.adminLogin.rejected]: (state, action) => {
            toast.error(action.error.message);
            state.loading = false;
            state.error = action.error;
        },
    },
});

export const {adminLogout, setReserveShares,setAdmin,setAdminNotifications ,setTotalUnseenAdminNotifications ,setShowDropdown} = adminSlice.actions;
export default adminSlice.reducer;
